import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '@paintscout/ui'
import { useDialogs, useIsMobile, Button, Hidden } from '@paintscout/ui'
import AddIcon from '@material-ui/icons/Add'
import CreateLocationDialog from 'src/components/dialogs/CreateLocationDialog'

const useStyles = makeStyles<Theme, NewLocationButtonProps>(
  (_theme) => ({
    root: {}
  }),
  { name: 'NewLocationButton' }
)

export interface NewLocationButtonProps {
  classes?: StyleClasses<typeof useStyles>
}

function NewLocationButton(props: NewLocationButtonProps) {
  const classes = useStyles(props)
  const { openDialog, dismissDialog } = useDialogs()
  const isMobile = useIsMobile()

  return (
    <div className={classes.root}>
      <Button
        {...props}
        icon={AddIcon}
        onClick={() => {
          openDialog(CreateLocationDialog, {
            onConfirm: dismissDialog,
            onCancel: dismissDialog
          })
        }}
        size={isMobile ? 'large' : 'medium'}
      >
        <>
          New <Hidden mdDown={true}>Location</Hidden>
        </>
      </Button>
    </div>
  )
}

export default NewLocationButton
